<div class="services-container" [class.services-container--icons-only]="iconsOnly">
  <div class="services-list" [class.services-list--row]="iconsOnly">
    <div class="service-item" *ngFor="let service of displayedServices" [class.service-item--icons-only]="iconsOnly">
      <div class="service-content" [class.service-content--icons-only]="iconsOnly">
        <app-icon
          [title]="service.name + (service.count > 1 ? ' (' + service.count + ')' : '')"
          [glyph]="service.icon"
          [size]="iconsOnly ? '18' : '22'"
          [color]="service.color"
        ></app-icon>
        <ng-container *ngIf="!iconsOnly">
          <span class="service-name" [title]="service.name">{{ service.name }}</span>
          <span class="service-count" *ngIf="service.count > 1">({{ service.count }})</span>
        </ng-container>
        <ng-container *ngIf="iconsOnly">
          <span class="service-count service-count--bubble" *ngIf="service.count > 1">{{ service.count }}</span>
        </ng-container>
      </div>
    </div>

    <div class="service-item more-button" *ngIf="hasMore">
      <a class="link link--dotted" (click)="showAllServices()">ещё</a>
    </div>
  </div>
</div>
